import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import ServicesBento from "@/components/landing/ServicesBento";
import TrustMarquee from "@/components/landing/TrustMarquee";
import SparePartsSection from "@/components/landing/SparePartsSection";
import BuySellSection from "@/components/landing/BuySellSection";
import AboutSection from "@/components/landing/AboutSection";
import Testimonials from "@/components/landing/Testimonials";
import LocationContact from "@/components/landing/LocationContact";
import Footer from "@/components/landing/Footer";
import WhatsAppButton from "@/components/landing/WhatsAppButton";

export default function LandingPage() {
  return (
    <main className="bg-white text-[#0A0A0A]" data-testid="landing-page">
      <Header />
      <Hero />
      <ServicesBento />
      <TrustMarquee />
      <SparePartsSection />
      <BuySellSection />
      <AboutSection />
      <Testimonials />
      <LocationContact />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
